import { SCHEDULER_OFFSETS_MINUTES } from '../constants/windows';

function uniqueDesc(values: number[]): number[] {
  const seen = new Set<number>();
  const out: number[] = [];
  for (const value of values) {
    const n = Math.round(value);
    if (!Number.isFinite(n) || n < 1 || seen.has(n)) continue;
    seen.add(n);
    out.push(n);
  }
  return out.sort((a, b) => b - a);
}

/** Banker/server cutoff reminders before window close. */
export function buildBankerCutoffOffsets(warningMinutes: number): number[] {
  const primary = Number.isFinite(warningMinutes) && warningMinutes > 0
    ? Math.round(warningMinutes)
    : 5;
  return uniqueDesc([...SCHEDULER_OFFSETS_MINUTES, primary, 1]);
}

/** Lister cutoff reminders (long + final minute). */
export function buildListerCutoffOffsets(warningMinutes: number): number[] {
  const primary = Number.isFinite(warningMinutes) && warningMinutes > 0
    ? Math.round(warningMinutes)
    : 10;
  const longLead = Math.max(primary, 10);
  return uniqueDesc([longLead, 1]);
}
